import {Component, ChangeDetectionStrategy} from '@angular/core';
import {TableFilterDirective} from "../../../directives/table-filter/table-filter.directive";


@Component({
  selector: 'app-table-filter-reset',
  standalone: true,
  imports: [],
  templateUrl: './table-filter-reset.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './table-filter-reset.component.scss'
})
export class TableFilterResetComponent {
  private tableFilter: TableFilterDirective | null = null;

  setTableFilter(tableFilter: TableFilterDirective): void {
    this.tableFilter = tableFilter;
  }

  onClicked(): void {
    this.tableFilter?.reset();
  }

  hasFilters(): boolean {
    return this.tableFilter?.hasFilters() ?? false;
  }
}
